<div class="tab-content-wrapper">
  <div class="row mb-2">
    <div class="col form-wrapper">
      <div
        class="image-preview d-flex justify-content-center align-items-center"
        (mouseenter)="showDeleteIcon = true"
        (mouseleave)="showDeleteIcon = false"
      >
        <img [src]="logo.href" *ngIf="logo"/>
        <mat-icon
          *ngIf="logo && showDeleteIcon"
          mat-list-icon
          class="button-delete float-end"
          (click)="onRemove()"
        >
          delete
        </mat-icon>
        <span *ngIf="!logo" class="no-logo">No logo uploaded</span>
      </div>
    </div>
  </div>
  <div>
    <mat-form-field class="image-input">
      <div>
        <mat-toolbar>
          <!-- Display filename -->
          <input matInput [(ngModel)]="fileAttr" readonly name="name"/>
          <!-- Browse Button -->
          <button mat-flat-button color="primary">Browse File</button>
        </mat-toolbar>
        <input
          type="file"
          #fileInput
          id="uploadFile"
          (change)="onSelect($event)"
          name="uploadFile"
          multiple="multiple"
          accept="image/*"
        />
      </div>
    </mat-form-field>
    <span class="file-type-info">Supported file types: jpeg, png</span>
  </div>
</div>
